// extracted by mini-css-extract-plugin
export default {"productGallery":"wJ-z","inQuickShop":"xJ-z"};